import mutations from './mutations'
import actions from './actions'
import getters from './getters'
const state = {
  podcasts: localStorage.getItem('podcasts') && JSON.parse(localStorage.getItem('podcasts'))  || [],
};

const module = {
  state,
  getters,
  mutations,
  actions
};

export default module;



// WEBPACK FOOTER //
// ./src/store/modules/podcasts/index.js